export const Nav = () => {
  return (
    <nav
      data-testid="site-nav"
      className="border-b border-seam bg-ground/80 backdrop-blur sticky top-0 z-40 px-6 py-4"
    >
      <div className="max-w-6xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <svg
            className="w-7 h-7 text-ember"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            aria-hidden="true"
          >
            <path
              className="flint-draw"
              pathLength="1"
              d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"
              fill="rgba(240,136,62,0.15)"
            />
          </svg>
          <span className="font-semibold text-lg tracking-wide text-white">
            Flintly
          </span>
        </div>
        <div className="flex items-center gap-6 text-sm text-smoke">
          <span className="hidden sm:inline-block text-xs uppercase tracking-widest text-ember">
            Context Compression
          </span>
          <a
            href="#waitlist"
            data-testid="nav-join-waitlist-link"
            className="text-white hover:text-ember transition-colors text-xs font-semibold uppercase tracking-wider"
          >
            Join Waitlist
          </a>
        </div>
      </div>
    </nav>
  );
};
